export const getIsPosting = state => state.getIn(['consultationsForm', 'isPosting']);
export const getIsGetting = state => state.getIn(['consultationsForm', 'isGetting']);
export const getErrMsg = state => state.getIn(['consultationsForm', 'errMsg']);
export const getLawyer = state => state.getIn(['consultationsForm', 'lawyer']);